"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateNameValueList = void 0;
const value_wrappers_1 = require("../value-wrappers");
const token_utils_1 = require("./token-utils");
function replaceVariablesWithValues(text, state = {}) {
    const variables = text.split(',');
    if ((0, token_utils_1.hasMissingVariableName)(variables, (0, token_utils_1.getStateKeys)(state)))
        return (0, value_wrappers_1.makeError)(`Unknown variable in expression: ${text}`);
    const values = variables.map((v) => (0, token_utils_1.getVariableFromState)(v, state));
    return (0, value_wrappers_1.makeValue)(values, variables);
}
function evaluateNameValueList(list, state) {
    return (0, value_wrappers_1.makeValue)(list);
}
exports.evaluateNameValueList = evaluateNameValueList;
